"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staff = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const c = (0, core_1.initContract)();
exports.staff = c.router({
    findUsers: {
        method: 'POST',
        path: '/users/find',
        body: schemas_1.FindUsersRequest,
        responses: {
            200: schemas_1.FindUsersResults,
        },
    },
    findWorkspaces: {
        method: 'POST',
        path: '/workspaces/find',
        body: schemas_1.FindWorkspacesRequest,
        responses: {
            200: schemas_1.FindWorkspacesResults,
        },
    },
    rehashEmails: {
        method: 'POST',
        path: '/users/rehash',
        body: schemas_1.EmptyBody,
        responses: {
            200: schemas_1.RehashEmailsResult,
        },
    },
    cloneWorkspace: {
        method: 'POST',
        path: '/workspaces/clone',
        body: zod_1.z.object({
            sourceId: schemas_1.Uuid,
            name: zod_1.z.string().optional(),
            ownerId: schemas_1.Uuid,
            workspaceUsers: zod_1.z.array(zod_1.z.object({
                userId: schemas_1.Uuid,
                isAdmin: zod_1.z.boolean(),
            })),
        }),
        responses: {
            201: zod_1.z.object({ id: schemas_1.Uuid }),
        },
    },
    getTemplates: {
        method: 'GET',
        path: '/templates',
        responses: {
            200: zod_1.z.object({
                templates: zod_1.z.array(schemas_1.TemplateWorkspaceData),
            }),
        },
    },
    createTemplate: {
        description: 'Convert a workspace into a template workspace. This operation removes all workspace members.',
        method: 'POST',
        path: '/templates',
        body: schemas_1.TemplateWorkspaceData,
        responses: Object.assign({ 201: schemas_1.TemplateWorkspaceData }, schemas_1.ScrapiErrorMessage),
    },
    updateTemplateMetadata: {
        method: 'PUT',
        path: '/templates/:code',
        body: schemas_1.TemplateWorkspaceData.omit({
            code: true,
            workspaceId: true,
        }).partial(),
        responses: {
            200: schemas_1.TemplateWorkspaceData,
        },
    },
    decommissionTemplate: {
        description: 'Convert a workspace template into a regular workspace. The caller will be added as the owner',
        method: 'PATCH',
        path: '/templates/:code/decommission',
        body: schemas_1.EmptyBody,
        responses: {
            200: zod_1.z.object({ workspaceId: schemas_1.Uuid }),
        },
    },
}, {
    pathPrefix: '/staff',
});
